import React, { useState } from "react";
import { string, number } from "prop-types";
import { subscribe } from "venuescanner-js/react/helpers";
import debounce from "lodash.debounce";
import SrpContainer from "../../containers/SrpContainer";
import FilterBar from "./FilterBar";
import Sort from "../Sort";
import cl from "classnames";
import MapToggle from "../MapToggle/MapToggle";
import classes from "./styles.module.scss";
import NoSsr from "@material-ui/core/NoSsr";
import isSSR from "venuescanner-js/services/isSSR";

const TopHeader = ({ title, numberOfResults }) => {
  // console.log('TopHeader')
  const [rendered, setRendered] = useState(false);
  // TODO: duplicated from inbox ViewContext
  const [isMobileDevice, setIsMobileDevice] = useState(
    isSSR() ? false : window.innerWidth < 1200
  );

  if (!isSSR()) {
    setTimeout(() => {
      setRendered(true);
    }, 500);
    window.addEventListener(
      "resize",
      debounce(function () {
        setIsMobileDevice(window.innerWidth < 1200);
      }, 150)
    );
  }

  return (
    <header>
      <div
        className={cl(classes.filterAndSort, {
          [classes.filtersRendered]: rendered,
        })}
      >
        <NoSsr>
          <FilterBar isMobileDevice={isMobileDevice} />
          {typeof window !== "undefined" && isMobileDevice ? <Sort /> : null}
          <MapToggle />
        </NoSsr>
      </div>
    </header>
  );
};

TopHeader.propTypes = {
  title: string.isRequired,
  numberOfResults: number,
};

export default subscribe({ SrpContainer })(({ srpContainer }) => (
  <TopHeader
    title={srpContainer.state.data.seo.header}
    numberOfResults={srpContainer.state.data.all}
  />
));
